import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { MainScene } from "./scenes/MainScene";

interface PhaserAnimationDemoProps {
}

interface PhaserAnimationDemoState {
}

const gameConfig: GameConfig = {
    title: "Animation Demo - Phaser",
    version: "0.0.1-demo",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 600 }
        }
    },
    backgroundColor: "#3A99D9"
};

class PhaserAnimationDemo extends React.Component<PhaserAnimationDemoProps, PhaserAnimationDemoState> {
    private game: Phaser.Game;
    constructor(props: PhaserAnimationDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserAnimationDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={MainScene} config={gameConfig} />
        </div>);
    }
}

export default PhaserAnimationDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserAnimationDemo/Main.tsx